import { CreateSalaryRangeDocument, CreateSalaryRangeMutation } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useCreateSalaryRange = () => {
  const [mutate] = useMutation(CreateSalaryRangeDocument, {
    extractorFn: (data: CreateSalaryRangeMutation) =>
      data.jobCatalogMutations.createJobcatalogSalaryRange,
  })

  const createLevel = (
    amountType: string,
    currency: string,
    legalEntitiesIds: string[],
    levelId: string,
    maxRange: number,
    minRange: number,
    salaryFrequency: string
  ) => {
    return mutate({
      variables: {
        amountType,
        currency,
        legalEntitiesIds,
        levelId,
        maxRange,
        minRange,
        salaryFrequency,
      },
    })
  }

  return createLevel
}

export default useCreateSalaryRange
